import { render, staticRenderFns } from "./ModalCreateTag.vue?vue&type=template&id=ad2a37d2&scoped=true&"
import script from "./ModalCreateTag.vue?vue&type=script&lang=ts&"
export * from "./ModalCreateTag.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCreateTag.vue?vue&type=style&index=0&id=ad2a37d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2a37d2",
  null
  
)

export default component.exports